module.exports = __webpack_public_path__ + "media/form_icons/otd-6ad43105.png";